import { useContext } from 'react';
import { ConfigContext } from '../../ConfigProvider';
// eslint-disable-next-line func-names
export default function () {
    var config = useContext(ConfigContext).config;
    return config;
}
//# sourceMappingURL=index.js.map